
export default function CampsSection() {
  const camps = [
    {
      title: 'Summer Soccer Camp',
      duration: 'June - August',
      description: 'Intensive week-long camps focusing on skill development, scrimmages, and fun activities.',
      features: ['Full-day programs', 'Lunch included', 'Skills competitions', 'Guest coaches'],
      price: '$299/week'
    },
    {
      title: 'Holiday Clinics',
      duration: 'Winter & Spring Break',
      description: 'Short-term clinics during school breaks to maintain fitness and improve skills.',
      features: ['Half-day sessions', 'Skill-focused training', 'Small groups', 'All skill levels'],
      price: '$89/day'
    },
    {
      title: 'Elite Training Camp',
      duration: 'Year-round',
      description: 'Advanced training for competitive players looking to take their game to the next level.',
      features: ['Advanced techniques', 'Tactical training', 'Video analysis', 'College prep'],
      price: '$199/weekend'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Seasonal Camps & Clinics
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Intensive training opportunities throughout the year
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {camps.map((camp, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300">
              <div className="text-center mb-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{camp.title}</h3>
                <p className="text-orange-600 font-semibold">{camp.duration}</p>
              </div>
              
              <p className="text-gray-600 mb-4">{camp.description}</p>
              
              <div className="mb-6">
                <h4 className="font-semibold text-gray-900 mb-2">Includes:</h4>
                <ul className="space-y-1">
                  {camp.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-gray-600">
                      <i className="ri-check-line text-green-500 mr-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
              
              <div className="text-center">
                <div className="text-2xl font-bold text-blue-600 mb-4">{camp.price}</div>
                <button className="w-full bg-purple-600 text-white py-2 px-4 rounded-lg font-semibold hover:bg-purple-700 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                  Learn More
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
